import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

export const Sidebar = styled.div`
  background: #fff;
  position: relative;
  z-index: 99000;
  filter: var(--elevation-4);
  font-family: 'Poppins', sans-serif;
`;

export const SidebarContent = styled.div`
  overflow: hidden;
  display: grid;
  grid-template-columns: 400px 0 0;
  grid-template-rows: 100vh;
  position: relative;
  @media (max-width: 768px) {
    grid-template-columns: calc(100vw - 50px) 0 0;
  }

  background: #fff;
  filter: var(--elevation-4);
  & > * {
    -webkit-transition: width 0.5s ease-in-out;
    -moz-transition: width 0.5s ease-in-out;
    -o-transition: width 0.5s ease-in-out;
    transition: width 0.5s ease-in-out;
    padding-bottom: 1.5rem;
    overflow: hidden;
  }
  ${(props) => {
    if (props.currentView === 'detail') {
      return css`
        grid-template-columns: 0 0 400px;
        @media (max-width: 768px) {
          grid-template-columns: 0 0 calc(100vw - 50px);
        }
      `;
    }
    if (props.currentView === 'location') {
      return css`
        grid-template-columns: 0 400px 0;
        @media (max-width: 768px) {
          grid-template-columns: 0 calc(100vw - 50px) 0;
        }
      `;
    }
    return null;
  }}
`;

export const SidebarFooter = styled.div`
  ${mixin.border()}
  ${mixin.text({ size: 100 })}
  border-width: 1px 0 0;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 1.5rem;
  z-index: 1000;
  background: #fff;
  padding: 0.25rem 0.75rem;
  line-height: 1rem;
  color: var(--neutral-800);
  a {
    display: inline-block;
    color: var(--neutral-800);
  }
  a:not(:first-child) {
    margin-left: 0.75rem;
    border-left: solid 1px var(--neutral-500);
    padding-left: 0.75rem;
  }
`;

export const IconWrap = styled.i`
  display: inline-grid !important;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 1em;
  height: 1em;
  vertical-align: middle;
  & > svg {
    fill: currentColor;
    stroke: currentColor;
    shape-rendering: geometricPrecision;
    height: 1em;
  }
  & > svg path {
    shape-rendering: geometricPrecision;
  }
  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
      height: ${size}px;
      & > svg {
        height: ${size}px;
      }
    `}
  ${({ color }) =>
    color &&
    css`
      color: var(--${color});
    `}
`;

export const SidebarHandle = styled.div`
  background: #000;
  color: #fff;
  border-radius: 0 0.5rem 0.5rem 0;
  height: 44px;
  line-height: 42px;
  width: 32px;
  text-align: center;
  position: absolute;
  right: -32px;
  top: 50%;
  margin-top: -20px;
  z-index: 98000;
  cursor: pointer;
  filter: var(--elevation-3);
`;
export const JobMapContainer = styled.main`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 100vh;
  background: #fff;
  font-family: 'Poppins', sans-serif;
  @media (max-width: 768px) {
    grid-template-columns: 100vw;
  }
  ${Sidebar} {
    -webkit-transition: width 0.5s ease-in-out;
    -moz-transition: width 0.5s ease-in-out;
    -o-transition: width 0.5s ease-in-out;
    transition: width 0.5s ease-in-out;
    width: 0px;
    @media (max-width: 768px) {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
    }
  }
  ${(props) =>
    props.showSidebar &&
    css`
      ${Sidebar} {
        width: 400px;
        @media (max-width: 768px) {
          width: calc(100vw - 50px);
        }
      }
    `}
`;

export const Map = styled.div`
  background: #ccc;
  position: relative;
`;

export const Logo = styled.img`
  position: absolute;
  right: 60px;
  top: 10px;
  height: 100px;
  width: 100px;
  object-fit: scale-down;
  border-radius: 1rem;
  border: solid 0.5rem #fff;
  background: #fff;
  filter: var(--elevation-3);
`;
